module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "with-child-centered",
    staticStyle: {
      "height": "100%"
    }
  }, [(_vm.getScheduled === false) ? _c('Loader') : _vm._e(), (_vm.scheduleByPatient.length > 0 && _vm.getScheduled) ? _c('div', {
    staticClass: "schedules-wrapper"
  }, [(false) ? _c('div', {
    staticClass: "with-child-centered"
  }, [_c('h4', [_vm._v("今日無病人須於此藥櫃操作")])]) : _c('SplitLayout', {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('div', {
    attrs: {
      "slot": "left"
    },
    slot: "left"
  }, [_c('h5', {
    staticClass: "text-center"
  }, [_vm._v("1.選擇病人")]), _c('div', {
    staticStyle: {
      "height": "418px",
      "overflow-y": "auto"
    }
  }, _vm._l((_vm.scheduleByPatient), function(patient, ind) {
    return _c('div', {
      class: {
        'surgery-item': true, 'sch-selected': ind === _vm.patientSelected
      },
      style: ({
        display: 'inline-block',
        width: '98%',
        backgroundColor: _vm.colormaps[(ind % _vm.colormaps.length)],
        color: 'white',
        border: '1px solid transparent'
      }),
      on: {
        "click": function($event) {
          return _vm.patientSelectFun(ind)
        }
      }
    }, [_c('p', [_c('span', {
      staticStyle: {
        "padding-right": "1rem"
      }
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": _vm.faUser,
        "color": "white"
      }
    })], 1), _c('strong', [_c('span', [_vm._v(_vm._s(patient.patient.med_record_number) + " ")]), _c('span', [_vm._v(_vm._s(patient.patient.name) + " ")]), (patient.patient.gender) ? _c('span', [_vm._v("( " + _vm._s(_vm._f("genderZh")(patient.patient.gender)) + " )")]) : _vm._e()]), _c('span', {
      staticClass: "float-right"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("areaFormat")(_vm.$store.state.device.systemArea)))]), _c('span', [_vm._v(_vm._s(patient.bed.code))])])])])
  }), 0)]), _c('div', {
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_c('h5', {
    staticClass: "text-center"
  }, [_vm._v("2.手術相關資訊")]), _c('div', {
    staticStyle: {
      "height": "418px",
      "overflow-y": "auto"
    }
  }, [(_vm.patientSelected !== undefined) ? _c('div', _vm._l((_vm.scheduleByPatient[_vm.patientSelected].schedules), function(schedule, ind) {
    return _c('div', {
      class: {
        'surgery-item': true
      },
      style: ({
        display: 'inline-block',
        width: '98%'
      }),
      on: {
        "click": function($event) {
          return _vm.selecteSchedule(schedule.id)
        }
      }
    }, [_c('p', [_c('span', {
      staticStyle: {
        "padding-right": "1rem"
      }
    }, [_c('font-awesome-icon', {
      staticStyle: {
        "font-size": "32px"
      },
      attrs: {
        "icon": _vm.faUserMd,
        "color": "black"
      }
    })], 1)]), (schedule.extra_info) ? _c('p', {
      domProps: {
        "innerHTML": _vm._s(_vm.extraInfoZh(JSON.parse(schedule.extra_info)))
      }
    }) : _vm._e(), _c('p')])
  }), 0) : _c('div', {
    staticClass: "with-child-centered"
  }, [_c('p', [_vm._v("請先選擇病人")])])])])])], 1) : _vm._e(), (_vm.scheduleByPatient.length === 0 && _vm.getScheduled) ? _c('div', {
    staticClass: "with-child-centered",
    on: {
      "click": _vm.manualSchedule
    }
  }, [_c('h4', [_vm._v("無排程資料")])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-335d45bd","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/flowComp/OperatingRoomScheduleList.vue
// module id = 1424
// module chunks = 1